function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var Gen = require('../vendor/mersenne').MersenneTwister19937;

function Mersenne() {
  var gen = new Gen();
  gen.init_genrand(new Date().getTime() % 1000000000);

  this.rand = function (max, min) {
    if (max === undefined) {
      min = 0;
      max = 32768;
    }

    return Math.floor(gen.genrand_real2() * (max - min) + min);
  };

  this.seed = function (S) {
    if (typeof S != 'number') {
      throw new Error("seed(S) must take numeric argument; is " + _typeof(S));
    }

    gen.init_genrand(S);
  };

  this.seed_array = function (A) {
    if (_typeof(A) != 'object') {
      throw new Error("seed_array(A) must take array of numbers; is " + _typeof(A));
    }

    gen.init_by_array(A, A.length);
  };
}

module.exports = Mersenne;